<template>
    <PdiSummary :userId="userId" :periods="periods" />
</template>

<script>
import { PdiSummary } from '@/views/components/summaries'
export default {
    name: 'PDIWidget',
    components: { PdiSummary },
    props: {
        userId: {
            type: String,
            required: true,
        },
    },
    computed: {
        periods() {
            return this.$store.state.filters.periods
        },
    },
}
</script>
